export default __webpack_public_path__ + "assets/audios/game-error.mp3";